export default __webpack_public_path__ + "static/media/date-icon.de06a074.svg";